import styled from "styled-components"

const Statistic = styled.span`
    margin-right: 15px;
    white-space: nowrap;
`
export const StatisticNotStarted = styled(Statistic)`
    color: ${(props) => props.theme.statisticNotStarted};
`
export const StatisticInProgress = styled(Statistic)`
    color: ${(props) => props.theme.statisticInProgress};
`
export const StatisticFailed = styled(Statistic)`
    color: ${(props) => props.theme.statisticFailed};
`
export const StatisticApproved = styled(Statistic)`
    color: ${(props) => props.theme.statisticApproved};
`
export const StatisticValue = styled.span`
    color: ${(props) => props.theme.statisticValue};
`

export const StatisticStatus = styled.span<{
    notStarted: boolean
    inProgress: boolean
    failed: boolean
    approved: boolean
}>`
    color: ${(props) => {
        if (props.notStarted) return props.theme.statisticNotStarted
        if (props.inProgress) return props.theme.statisticInProgress
        if (props.failed) return props.theme.statisticFailed
        if (props.approved) return props.theme.statisticApproved
        return "inherit"
    }};
`
